import React from 'react';
import _ from 'lodash';
import {Segment, Header} from 'semantic-ui-react';

import {ContentDispatch} from 'framework';

export const MoreDetails = ({moreDetailsConfig, sourcePath, attachedItemName, tier}) => {
  return (
    <div className={'padding-bottom request-details--v2__tier' + (tier || 0)}>
      {!_.isEmpty(moreDetailsConfig) && (
        <Segment>
          <Header as="h5">
            More Details{attachedItemName ? ` for ${attachedItemName}` : ''}.
          </Header>
          {_.map(moreDetailsConfig, (question, index) => (
            <ContentDispatch config={question} rootPath={sourcePath} key={index} />
          ))}
        </Segment>
      )}
    </div>
  );
};

export default MoreDetails;
